import { Input } from 'antd';
import { useAppDispatch } from '../../../../../redux/store';
import { updatePensionItem } from '../../../../../redux/reducers/onboarding/sliceReducer';
import { getError } from '../../../../../common/api/utils/getError';

interface IProps {
    keyValue: string;
    index: number;
    value: string;
    getError: (fieldName: string) => string;
    disabled?: boolean;
}

const numberKeys = ['employeeContribution', 'employerContribution'];

const PensionInput = (props: IProps) => {
    const dispatch = useAppDispatch();
    const { keyValue, index, value, disabled, getError } = props;
    return (
        <Input
            bordered={false}
            type="number"
            value={value}
            style={{
                fontSize: '12px',
                border: getError(`data.plans[${index}].${keyValue}`) ? '1px solid #e02b1d' : '',
                borderRadius: getError(`data.plans[${index}].${keyValue}`) ? '5px' : '',
            }}
            onChange={(e) => {
                dispatch(
                    updatePensionItem({
                        index,
                        key: keyValue,
                        value: numberKeys.includes(keyValue)
                            ? e.target.value === ''
                                ? null
                                : +e.target.value
                            : e.target.value,
                    })
                );
            }}
            disabled={!!disabled}
        />
    );
};

export default PensionInput;
